// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__j1M8E","subheader":"ReorderModal_subheader__19dKD","listWrap":"ReorderModal_listWrap__pnmP3"};